// extracted by mini-css-extract-plugin
module.exports = {"CreditSlider":"CreditSlider_CreditSlider__TBhgp"};